import React from "react";
import { useSearchParams } from "react-router-dom";
import { FeedGrid } from "@/components/FeedGrid";
import { useI18n } from "@/i18n";

export default function SearchPage() {
  const [params] = useSearchParams();
  const { t } = useI18n();
  const q = params.get("q") || "";
  return <FeedGrid key={q} baseParams={{ q }} title={`${t("search.title")}: "${q}"`} description={t("search.desc")} />;
}
